import { Chip } from 'ui';

export const AIBadge = () => {
  return <Chip size="small" color="primary" label="AI" />;
};
